import { OpgaveAfsnit } from './OpgaveAfsnit';
import { Delopgave } from './Delopgave'; 
export class Opgave {
        public id: string;
        public titel: string;
        public billedId: string;
        public oftestStilledeSpoergsmaalIndhold: string;
        public opgaveAfsnit: OpgaveAfsnit[];
        public delopgaver: Delopgave[];
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/Opgave.ts